<div
  *ngIf="showModal"
  id="supplierVerificationModal"
  class="modal fixed inset-0 bg-black bg-opacity-70 flex justify-center items-start z-50 overflow-y-auto"
  (click)="closeModal()"
>
  <div
    class="relative card_color rounded-lg max-w-md w-full flex flex-col md:flex-row text_white overflow-hidden shadow-lg mx-4 sm:mx-8 my-10 max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="closeModal()"
    >
      &times;
    </button>

    <!-- Contenido del modal -->
    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-center card_color rounded-b-lg md:rounded-r-lg md:rounded-bl-none"
    >
      <div class="mb-4 flex items-center space-x-3">
        <i class="pi pi-exclamation-triangle text-3xl"></i>
        <h2 class="text-xl sm:text-2xl font-medium text-left">ATENCIÓN</h2>
      </div>
      <p class="text-md font-light mb-2 sm:mb-3">
        Las <strong>operaciones registradas</strong> con este
        <strong>proveedor</strong> serán <strong>cobradas</strong>.
      </p>
      <p class="text-md font-light mb-2 sm:mb-3">
        Toma tus <strong>precauciones</strong> y realiza apuestas pequeñas.
      </p>

      <!-- Botones -->
      <div class="flex flex-row gap-2">
        <button
          type="button"
          class="w-full my-2 block py-3 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg"
          (click)="confirmLaunch()"
        >
          <div class="inline-flex items-center">Abrir Juego</div>
        </button>
      </div>
    </div>
  </div>
</div>
